module.exports = __webpack_public_path__ + "/images/logo-fr-maisons-du-monde.6e1f452.png";